import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { MessageBoxTypesEnum } from '@dch/pxs-angular-design-system/src/lib/messages/message-box';
import { resetPdfDownload } from 'src/app/state/actions';
import { ApplicationState } from 'src/app/state/reducers';
import { selectDownloadPdf } from 'src/app/state/selectors/pdf-download.selectors';

@Component({
  selector: 'my-bill-pdf-error-overlayer',
  templateUrl: './pdf-error-overlayer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PdfErrorOverlayerComponent {
  messageBoxTypeError = MessageBoxTypesEnum.Error;

  readonly selectDownloadPdf$ = this.store.select(selectDownloadPdf);

  constructor(private store: Store<ApplicationState>) {}

  closeModal(): void {
    this.store.dispatch(resetPdfDownload());
  }
}
